module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-taiguo.2ff91234.jpg";